import { Moment } from 'moment'
import React, { useContext } from 'react'

import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'
import SaveTripItemButton from 'tripPlanner/components/Buttons/SaveTripItemButton'
import ViewMoreOffersCta from 'tripPlanner/components/Buttons/ViewMoreOffersCta'
import DeepLinkButtons from 'tripPlanner/components/ItemCard/Common/DeepLinkButtons'
import { VIEW_OFFER_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import { TripItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { itemSectionId } from 'tripPlanner/utils/itemSection'

interface Props {
  item: TripItem
  isOfferAvailable: boolean
  offerId?: string
  checkIn?: Moment
  checkOut?: Moment
}

export const PlannedItemCtaContent = (props: Props) => {
  const { isOfferAvailable, offerId, checkIn, checkOut, item } = props

  const viewAsTemplate = useContext(TripContext)?.viewAsTemplate
  const isPublicTrip = useContext(TripContext)?.isPublicTrip

  if (!isOfferAvailable) {
    return (
      <ViewMoreOffersCta
        offerId={offerId}
        checkIn={checkIn}
        checkOut={checkOut}
        sectionId={itemSectionId(item.id)}
        tripId={item.tripId}
      />
    )
  } else if (isLeBookmark(item)) {
    if (viewAsTemplate || isPublicTrip) {
      return (
        <Group direction="horizontal" gap={12}>
          <SaveTripItemButton item={item} />
          <TextButton kind="primary" nonInteractable>
            {VIEW_OFFER_COPY}
          </TextButton>
        </Group>
      )
    } else {
      return <DeepLinkButtons item={item} />
    }
  }

  return null
}
